import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  "data-bs-backdrop": "static",
  id: "successModal",
  tabindex: "-1",
  "aria-labelledby": "successModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_6 = { class: "modal-body p-0" }
const _hoisted_7 = { class: "text-center py-4 mb-4 border-bottom" }
const _hoisted_8 = { class: "d-flex justify-content-center mb-4" }

import { PropType } from 'vue'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'


export default /*#__PURE__*/_defineComponent({
  props: {
  reset: {
    type: Function as PropType<() => void | undefined>,
  },
  serverErrorPortfolios: String,
  idCorporation: String,
},
  setup(__props) {

const props = __props



const messageComplete = () => {
  if (props.serverErrorPortfolios === 'create') {
    return 'SG43createError'
  }
  if (props.serverErrorPortfolios === 'update') {
    return 'SG43updateError'
  }
  return !props.idCorporation ? 'registered' : 'updateComplete'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(__props.idCorporation ? _unref(translate)('editWorkHistory') : _unref(translate)('addWorkHistory')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.reset && __props.reset(...args))),
            "aria-label": "Close"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(translate)(messageComplete())), 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Button, {
              type: 'secondary',
              onClick: __props.reset,
              "data-bs-dismiss": "modal",
              title: _unref(translate)('close')
            }, null, 8, ["onClick", "title"])
          ])
        ])
      ])
    ])
  ]))
}
}

})